export const environment = {
    production: false,
    apiUrl: 'https://api.cca.qual.cawita.com',
    assetUrl: 'https://assets.cca.qual.cawita.com',
    customerSpaceUrl: 'https://share.cca.qual.cawita.com',
    protectedAssetPath: 'private',
    publicAssetPath: 'public',
    recaptchaSiteKey: '6LfgUtoaAAAAAAxFBLNU6FcAhEboBvEl6G0ZBiuR'
};